module.exports = __webpack_public_path__ + "img/plug-left.f422b1bf.svg";